import { render, staticRenderFns } from "./modal-confirm.vue?vue&type=template&id=426b642e&"
import script from "./modal-confirm.vue?vue&type=script&lang=js&"
export * from "./modal-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports